import { memo, useCallback } from 'react'
import cn from 'classnames'
import IconAdd from 'remixicon/icons/System/add-line.svg?react'
import { useFieldArray } from 'shared/forms/useFieldArray'
import { LinkButton } from 'src/components/extend'

import { DEFAULT_CARGO_ITEM } from './constants'
import { OrderCargoSeparateItem } from './OrderCargoSeparateItem'
import OrderCargoSeparateWarning from './OrderCargoSeparateWarning'

interface IProps {
  className?: string
  onOpenCustomScheduler?: () => void
  onOpenPalletScheduler?: () => void
}

export const OrderCargoSeparate = memo<IProps>(function OrderCargoSeparate({
  className,
  onOpenCustomScheduler,
  onOpenPalletScheduler
}) {
  const {
    fields: { push, map }
  } = useFieldArray('cargo')

  const handleAdd = useCallback(() => push(DEFAULT_CARGO_ITEM), [push])

  return (
    <div className={cn(className, '@container')}>
      {map((name, index) => (
        <OrderCargoSeparateItem
          key={name}
          className={cn(index && 'mt-4')}
          index={index}
          name={name}
          onOpenCustomScheduler={onOpenCustomScheduler}
          onOpenPalletScheduler={onOpenPalletScheduler}
        />
      ))}
      <LinkButton
        className="link mt-4 inline-flex items-center !text-on-surface-link"
        iconLeft={<IconAdd className="mr-2" containerSize="xs" size="xs" />}
        onClick={handleAdd}
      >
        Добавить новое грузоместо
      </LinkButton>
      <OrderCargoSeparateWarning />
    </div>
  )
})
